
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class TestResultMuteGrid extends SiteEntityGrid<TestResultMuteRow, any> {
        protected getColumnsKey() { return 'Data.TestResultMute'; }
        protected getDialogType() { return TestResultMuteDialog; }
        protected getIdProperty() { return TestResultMuteRow.idProperty; }
        protected getLocalTextPrefix() { return TestResultMuteRow.localTextPrefix; }
        protected getService() { return TestResultMuteService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            return super.getButtons().filter(x => x.cssClass != "add-button");
        }
    }
}